// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import uuid from "react-native-uuid";
import { ContentState } from "draft-js";
// import { ContentState, convertToRaw } from "draft-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Toastr, Button, Label, Input } from "@revvsales/components";
import { Button, Label, Input } from "@revvsales/components";

// Components Imports
import { ReactSelect } from "../../../commonComponents";

import OptionView from "./OptionView";

// Actions Imports
import {
  executeCommand,
  updateDocumentComponentAction,
} from "../../../actions/DocumentActions";
import { DocumentTemplateActions } from "../../../actions";
import ClauseOptionCommand from "../../../commands/clauseOptionCommand";

// services import
// import {
//   createClauseOptions,
//   updateTemplateComponentService,
//   updateClauseOptionsService,
// } from "../../../actions/DocumentTemplateActions/templateService";

// Contants imports
import { TEMPLATE } from "../../../constants";

// Util imports
import { getClauseOptionValue } from "../../../utils/documentUtils";

// Destructuring
const {
  nukeClauseOptions,
  addDynamicFieldinList,
  toggleDynamicFieldView,
  addDynamicFieldinListAsync,
  updateClauseOptionsAndSection,
} = DocumentTemplateActions;

const { CLAUSES_OPTIONS, CLAUSE_TYPE } = TEMPLATE;

class ClauseOptions extends Component {
  state = {
    id: null,
    type: null,
    name: "",
    description: "",
    clauses: [],
    activeID: null,
    defaultValue: null,
    errMsg: null,
    oldClauseInfo: null, // is being used for undo/redo purpose
  };

  componentDidMount() {
    const { clause, section } = this.props;
    this._updateClauseParams(clause, section);
  }

  componentDidUpdate(prevProps) {
    const { clause, section } = this.props;
    if (prevProps.clause !== clause || prevProps.section !== section) {
      this._updateClauseParams(clause, section);
    }
  }

  _isNewField = clauseOptionId => {
    // returns if the field beign added is new or updated
    const { fields } = this.props;
    const fieldIndex = fields.findIndex(field => field.id === clauseOptionId);
    if (fieldIndex > -1) {
      return false;
    }
    return true;
  };

  _updateClauseParams = (clause, section) => {
    if (clause && clause.id) {
      const {
        id,
        label: name,
        description,
        meta: { clauses: clauseOptions, subtype: type, default: defaultValue },
      } = clause;

      let clauses;
      if (type === CLAUSES_OPTIONS.FREE_TEXT) {
        clauses = [
          {
            id: uuid.v4(),
            ...getClauseOptionValue(defaultValue || null),
          },
        ];
      } else {
        clauses = clauseOptions.map(cl => ({
          ...cl,
          ...getClauseOptionValue(cl.value),
        }));
      }
      this.setState({
        id,
        type,
        name,
        description,
        clauses,
        defaultValue,
        oldClauseInfo: {
          type,
          name,
          description,
          clauses,
          defaultValue,
        },
      });
    } else if (section) {
      const { data } = section;
      const clauses = [
        {
          id: uuid.v4(),
          data,
        },
      ];
      this.setState({ clauses });
    }
  };

  _addOption = () => {
    const { clauses } = this.state;
    const newOption = {
      id: uuid.v4(),
      data: ContentState.createFromText(""),
    };
    clauses.push(newOption);
    this.setState({ clauses, activeID: newOption.id });
  };

  _addDefaultText = () => {
    const { clauses, defaultValue } = this.state;
    if (defaultValue) {
      this.setState({ defaultValue: null });
    } else if (!clauses || (Array.isArray(clauses) && clauses.length === 0)) {
      const newClauses = [
        {
          id: uuid.v4(),
          value: null,
        },
      ];
      this.setState({ clauses: newClauses, defaultValue: true });
    } else {
      this.setState({ defaultValue: true });
    }
  };

  _updateClauseType = clauseType => {
    const { type } = this.state;
    if (type !== clauseType) {
      if (
        clauseType === CLAUSES_OPTIONS.MULTI_SELECT ||
        clauseType === CLAUSES_OPTIONS.OPTIONAL
      ) {
        this.setState({ type: clauseType, defaultValue: [] });
      } else {
        this.setState({ type: clauseType, defaultValue: null });
      }
    }
  };

  _updateOption = (id, data) => {
    const { clauses } = this.state;
    const updatedOptions = clauses.map(option => ({
      ...option,
      data: option.id === id ? data : option.data,
    }));
    this.setState({ clauses: updatedOptions });
  };

  _deleteOption = id => {
    const { clauses } = this.state;
    let { defaultValue } = this.state;
    if (Array.isArray(clauses) && clauses.length === 1) {
      const errMsg = "Options list cannot be empty";
      this.setState({ errMsg });
    } else {
      const updatedOptions = clauses.filter(option => option.id !== id);
      if (Array.isArray(defaultValue) && defaultValue.includes(id)) {
        defaultValue = defaultValue.filter(optionID => optionID !== id);
      } else if (defaultValue === id) {
        defaultValue = null;
      }
      this.setState({ clauses: updatedOptions, defaultValue });
    }
  };

  _updateDefaultOption = defaultID => {
    const { defaultValue, type } = this.state;
    let updatedDefaultValue;
    if (
      type === CLAUSES_OPTIONS.MULTI_SELECT ||
      type === CLAUSES_OPTIONS.OPTIONAL
    ) {
      // default id should have list of all the options marked as default
      if (Array.isArray(defaultValue)) {
        if (defaultValue.includes(defaultID)) {
          updatedDefaultValue = defaultValue.filter(dID => dID !== defaultID);
        } else {
          defaultValue.push(defaultID);
          updatedDefaultValue = defaultValue;
        }
      } else {
        updatedDefaultValue = [defaultID];
      }
    } else if (defaultID === defaultValue) {
      updatedDefaultValue = null;
    } else {
      updatedDefaultValue = defaultID;
    }
    this.setState({ defaultValue: updatedDefaultValue });
  };

  _updateActiveOption = id => {
    this.setState({ activeID: id });
  };

  _validateClauseOption = () => {
    const { type, name, description, clauses } = this.state;
    let errMsg;
    if (name === "" || description === "" || type === null) {
      errMsg = "Clause Options name, description and type can't be empty.";
    } else if (
      type !== CLAUSES_OPTIONS.FREE_TEXT &&
      Array.isArray(clauses) &&
      clauses.length === 0
    ) {
      errMsg = "Options cannot be empty for this clause type.";
    } else if (
      type === CLAUSES_OPTIONS.SINGLE_SELECT &&
      Array.isArray(clauses) &&
      clauses.length < 2
    ) {
      errMsg = "Create atleast 2 options for Single Select Clause Options.";
    } else if (type !== CLAUSES_OPTIONS.FREE_TEXT && Array.isArray(clauses)) {
      clauses.forEach((option, index) => {
        if (option.data.getPlainText().trim() === "") {
          errMsg = `Option ${index +
            1} is empty. Either add something to the option or remove it.`;
        }
      });
    }
    return errMsg;
  };

  _saveClauseOption = () => {
    const { id, type, name, description, clauses, defaultValue } = this.state;

    // Validate the clause options
    const errMsg = this._validateClauseOption();
    if (errMsg) {
      this.setState({ errMsg });
    } else {
      const clauseOption = new ClauseOptionCommand({
        id,
        type,
        name,
        description,
        clauses: clauses ? [...clauses] : [],
        fields: this.props.fields ? [...this.props.fields] : [],
        defaultValue,
        section: this.props.section ? { ...this.props.section } : {},
        fieldsUsed: this.props.fieldsUsed ? { ...this.props.fieldsUsed } : {},
        updateComponent: this.props.updateComponent,
        oldClauseInfo: id ? { ...this.state.oldClauseInfo } : null,
        addDynamicFieldinListAsync: this.props.addDynamicFieldinListAsync,
        updateDocumentComponentAction: this.props.updateDocumentComponentAction,
        updateClauseOptionsAndSection: this.props.updateClauseOptionsAndSection,
        toggleDynamicFieldView: this.props.toggleDynamicFieldView,
      });
      this.props.executeCommand(clauseOption);
    }
  };

  _discardClauseOption = () => {
    this.props.nukeClauseOptions();
  };

  _checkDefault = optionID => {
    const { defaultValue, type } = this.state;
    if (
      type === CLAUSES_OPTIONS.MULTI_SELECT ||
      type === CLAUSES_OPTIONS.OPTIONAL
    ) {
      return Array.isArray(defaultValue) && defaultValue.includes(optionID);
    }
    return optionID === defaultValue;
  };

  render() {
    const {
      id,
      type,
      name,
      description,
      activeID,
      errMsg,
      clauses,
      defaultValue,
    } = this.state;
    const clauseType = CLAUSE_TYPE.find(ct => ct.type === type);
    const clauseLabel = clauseType ? clauseType.label : null;
    const selectStyles = {
      menu: base => ({
        ...base,
        zIndex: 100,
      }),
    };

    let errSpace = null;
    if (errMsg) {
      errSpace = (
        <div
          className="error-message-container"
          data-test="clauseoptions-error-message-container">
          <div
            className="error-message-wrapper"
            data-test="clauseoptions-error-message-wrapper">
            <span
              className="error-message-icon"
              data-test="clauseoptions-error-message-icon">
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </span>
            {errMsg}
          </div>
        </div>
      );
    }

    return (
      <div>
        <div
          className="document-clause-options animated slideinright"
          data-test="clauseoptions-document-clause-options-animated-slideinright"
          id="document-clause-options-id">
          <div
            className="clause-options-header"
            data-test="clauseoptions-clause-options-header">
            <span
              className="btn-icon clause-options-back-button"
              data-test="clauseoptions-clause-options-back-button"
              onClick={this._discardClauseOption}
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}>
              <FontAwesomeIcon icon={["far", "angle-left"]} />
            </span>
            Add clause options
            <div
              className="clause-options-btns"
              data-test="clauseoptions-clause-options-btns">
              <Button
                className="btn-transparent"
                data-test="clauseoptions-discard-button"
                id="document-clause-options-id-discard-btn"
                onClick={this._discardClauseOption}>
                Discard
              </Button>
              <Button
                onClick={this._saveClauseOption}
                data-test="clauseoptions-save-button"
                id="document-clause-options-id-save-btn">
                Save
              </Button>
            </div>
          </div>
          {errSpace}
          <div
            className="clause-options-body"
            data-test="clauseoptions-clause-options-body">
            <div
              className="clause-options-name"
              data-test="clauseoptions-clause-options-name">
              <Label
                htmlFor="clause-options-name-box"
                data-test="clauseoptions-clause-options-name-box">
                <span data-test="clauseoptions-clause-label">Clause Label</span>
              </Label>
              <div
                className="clause-options-name-box"
                data-test="clauseoptions-clause-options-name-box">
                <Input
                  autoFocus
                  type="text"
                  data-test="clauseoptions-clause-name-input"
                  onChange={event =>
                    this.setState({ name: event.target.value, errMsg: null })
                  }
                  isAutoFocus
                  value={name}
                  placeholder="Enter Clause Label"
                />
              </div>
            </div>
            <div
              className="clause-options-desc"
              data-test="clauseoptions-clause-options-desc">
              <Label
                htmlFor="clause-options-desc-box"
                data-test="clauseoptions-clause-options-desc-box">
                <span data-test="clauseoptions-clause-description">
                  Clause Description
                </span>
              </Label>
              <div
                className="clause-options-desc-box"
                data-test="clauseoptions-clause-options-desc-box">
                <Input
                  type="text"
                  data-test="clauseoptions-clause-descriotion-input"
                  onChange={event =>
                    this.setState({
                      description: event.target.value,
                      errMsg: null,
                    })
                  }
                  value={description}
                  placeholder="Enter Clause description"
                />
              </div>
            </div>
            <div
              className="clause-options-type"
              data-test="clauseoptions-clause-options-type">
              <Label
                htmlFor="clause-option-type-dropdown"
                data-test="clauseoptions-clause-option-type">
                Clause Type
              </Label>
              <div
                className="clause-option-type-dropdown"
                data-test="clauseoptions-clause-option-type-dropdown">
                {id ? (
                  <Input
                    type="text"
                    data-test="clauseoptions-clause-type-input"
                    value={clauseLabel}
                    disabled
                  />
                ) : (
                  <ReactSelect
                    onChange={value => this._updateClauseType(value.value)}
                    options={CLAUSE_TYPE}
                    value={clauseLabel}
                    valueKey="type"
                    labelKey="label"
                    data-test="clauseoptions-clause-type-value"
                    styles={selectStyles}
                  />
                )}
              </div>
            </div>

            {type !== CLAUSES_OPTIONS.FREE_TEXT && (
              <div
                className="clause-options-list"
                data-test="clauseoptions-options-list">
                {clauses.map((option, index) => (
                  <OptionView
                    key={option.id}
                    count={index + 1}
                    option={option}
                    isActive={option.id === activeID}
                    isDefault={this._checkDefault(option.id)}
                    updateOption={this._updateOption}
                    deleteOption={this._deleteOption}
                    toggleDefaultOption={this._updateDefaultOption}
                    toggleActiveOption={this._updateActiveOption}
                  />
                ))}
              </div>
            )}
            {type === CLAUSES_OPTIONS.FREE_TEXT && (
              <div
                className="clause-options-view-default"
                data-test="clauseoptions-options-view-default">
                <div>
                  <Input
                    className="clause-options-view-checkbox"
                    data-test="clauseoptions-options-view-checkbox"
                    type="checkbox"
                    checked={defaultValue}
                    onChange={this._addDefaultText}
                  />
                  <Label
                    htmlFor="clause-options-view-checkbox"
                    data-test="clauseoptions-options-view-checkbox-label">
                    Add default text to this clause
                  </Label>
                </div>
              </div>
            )}
            {type === CLAUSES_OPTIONS.FREE_TEXT &&
              defaultValue &&
              Array.isArray(clauses) &&
              clauses.length > 0 && (
                <div
                  className="clause-options-list"
                  data-test="clauseoptions-options-list-view">
                  <OptionView
                    key={clauses[0].id}
                    type={type}
                    count={1}
                    option={clauses[0]}
                    isActive={clauses[0].id === activeID}
                    updateOption={this._updateOption}
                    toggleActiveOption={this._updateActiveOption}
                  />
                </div>
              )}
            {type !== CLAUSES_OPTIONS.FREE_TEXT && !activeID && (
              <div
                className="clause-options-add-option"
                data-test="clauseoptions-options-add-option-button-text">
                <Button
                  className="revv-btn-secondary-sm"
                  data-test="clauseoptions-options-add-option-button"
                  onClick={this._addOption}
                  onKeyDown={() => {}}
                  role="button"
                  tabIndex={0}>
                  <i>
                    <FontAwesomeIcon icon={["far", "plus"]} />
                  </i>
                  Add clause option
                </Button>
              </div>
            )}
          </div>
          {/* <div className="clause-options-action" /> */}
        </div>
        <div className="right-pane-bg" />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    clauseOptions: { section, clause },
    dynamicFields: { fields },
    template: { fields_used: dynamicFieldsUsed },
  } = state.TemplateStore;

  // Create a map for fieldsUsed obj
  const fieldsUsed = {};
  dynamicFieldsUsed.forEach(field => {
    fieldsUsed[field.id] = field;
  });

  return { clause, fields, fieldsUsed, section };
};

const mapDispatchToProps = {
  executeCommand,
  nukeClauseOptions,
  toggleDynamicFieldView,
  addDynamicFieldinList,
  addDynamicFieldinListAsync,
  updateDocumentComponentAction,
  updateClauseOptionsAndSection,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClauseOptions);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/ClauseOptions/ClauseOptions.js